<template>
  <!-- output one line of the productinfopage -->
  <v-container fluid class="product-info-line pa-0">
    <v-row no-gutters class="pa-0 mb-4 flex-nowrap" align="center">

      <v-icon :class="iconClass" class="mr-2">{{ lineIconText }}
      </v-icon>

      <slot />

    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    lineIcon: {
      type: String,
      default: "check"
    }
  },
  computed: {
    lineIconText: function () {
      if (this.lineIcon === "yolig") {
        return "favorite_border"; //favorite_border favorite star
      } else {
        return this.lineIcon;
      }
    },
    iconClass: function () {
      if (this.lineIcon === "star") {
        return "yellow-star";
      }
      else if (this.lineIcon === "yolig") {
        return "green-star";
      }
      else {
        return "black87";
      }
    }
  }
};
</script>
<style>
.product-info-line .yellow-star {
  color: #FFCC62 !important;
}
.product-info-line .blue-star {
  color: #0085CF !important;
}
.product-info-line .green-star {
  color: #3DAD47 !important;
}
</style>
